export const Marquee = ({ items, dark = true, className = "" }) => {
  const row = [...items, ...items];
  return (
    <div
      className={`overflow-hidden border-y ${
        dark ? "border-white/10 bg-[#0A0A0A]" : "border-black/10 bg-[#F4F4F0]"
      } py-6 md:py-8 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee-slow flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`font-serif text-3xl md:text-5xl font-light italic ${
                i % 2 === 0
                  ? "text-outline"
                  : dark
                  ? "text-[#F4F4F0]/80"
                  : "text-[#0A0A0A]/70"
              }`}
            >
              {item}
            </span>
            <span className={`h-1.5 w-1.5 rotate-45 ${dark ? "bg-[#047857]" : "bg-[#047857]"}`} />
          </span>
        ))}
      </div>
    </div>
  );
};
